import { render, staticRenderFns } from "./AIFormAssistant.vue?vue&type=template&id=dfa28bf4&scoped=true"
import script from "./AIFormAssistant.vue?vue&type=script&lang=js"
export * from "./AIFormAssistant.vue?vue&type=script&lang=js"
import style0 from "./AIFormAssistant.vue?vue&type=style&index=0&id=dfa28bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa28bf4",
  null
  
)

export default component.exports